var angular = require('angular');
var Promise = require('bluebird');
var ApplicationAPI = require('../../../common/api').Application;

 angular
  .module("app.directives")
  .directive('appStatsFunder', function(ngDialog){
    return {
      restrict: 'E',
      scope:{
          applicationId: "="
      },
      template: require('./index.pug'),
      replace:true,
      link: function(scope, element, attrs){


        scope.init = function(){
            ApplicationAPI.GetApplicationStatsOverview(scope.applicationId).then(function(result) {
              scope.stats = result;
            })
        }
        scope.init();
      }
    }
  })
